// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3tER_","large":"styles_large__xijag"};